import { createFileRoute } from '@tanstack/react-router'

import { PageLayout } from '@/components/ui/page'

import { ProductCreateForm } from '@/features/product/components/product-form'

export const Route = createFileRoute('/_app/product/create')({
	component: Component,
})

function Component() {
	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/product', 'Produk'],
					['/product/create', 'Buat baru'],
				]}
			/>
			<ProductCreateForm />
		</PageLayout.Root>
	)
}
